/** Small shared formatters for the Expense Capture screens. */

export function formatMoney(amount: number | null | undefined, currency = 'EUR'): string {
    if (amount === null || amount === undefined) return '—';
    try {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount);
    } catch {
        return `${amount.toFixed(2)} ${currency}`;
    }
}

/** ISO yyyy-mm-dd → dd.mm.yyyy (no Date parsing → no timezone shift). */
export function formatDate(iso: string | null | undefined): string {
    if (!iso) return '—';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

/** Current month key YYYY-MM in local time (no UTC shift). */
export function currentMonthKey(): string {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
